import { useApiClient } from '../client'

export const POST_REFERRALS_CJE_ENDPOINT = '/core/v2/referrals/cje/'

export type PostReferralsCjePayload = {
  cjevent: string
  aid?: string
  pid?: string
}

export function postReferralsCje (payload: PostReferralsCjePayload) {
  const apiClient = useApiClient()
  const data: PostReferralsCjePayload = {
    cjevent: payload.cjevent,
  }

  if (payload.aid) {
    data.aid = payload.aid
  }

  if (payload.pid) {
    data.pid = payload.pid
  }

  return apiClient.post<void>({
    url: POST_REFERRALS_CJE_ENDPOINT,
    data,
    withCredentials: true,
  })
}
